import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Importa o CSS do Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

// Importa o JavaScript do Bootstrap e Popper.js
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

createApp(App).use(router).mount('#app');
